module.exports = __webpack_public_path__ + "img/home-banner.9bbba0e5.png";